import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { ClientDocument } from '../../core/models/client-document';
import { Subject, takeUntil } from 'rxjs';
import { MatterService } from '../../core/services/matter.service';
import { OTHER_OPTION } from '../../core/shared/constants';

export interface IClientDocumentSelection {
  document: ClientDocument | null;
  description: string | null;
}


@Component({
  selector: 'app-document-select',
  templateUrl: './document-select.component.html',
  styleUrl: './document-select.component.scss'
})
export class DocumentSelectComponent implements OnDestroy, OnInit {


  private destroy$ = new Subject<void>();

  @Input() matterId: string | undefined | null = null;
  @Input() documentSelection: ClientDocument[] = [];
  @Input() isMessageAttachment: boolean = false;

  @Output() onSelectionChanged = new EventEmitter<{ selection: IClientDocumentSelection }>();

  @ViewChild('descriptionInput',{ static: false }) descriptionInput!: ElementRef<HTMLInputElement>;

  value: ClientDocument | string | null = '';
  docDescription: string | null = null;
  selectedDocumentId: string | null = null;
  hasDocuments: boolean = false;

  constructor(
    private matterService: MatterService,
    private elementRef: ElementRef
  ) {

  }

  ngOnInit(): void {
    this.hasDocuments = this.documentSelection.length > 0;
  }


  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private focusOnDescriptionInput(): void {
    if (this.value === OTHER_OPTION) {
      setTimeout(() => {
        const input = this.descriptionInput?.nativeElement;
        if (input) {
          input.focus({
            preventScroll: true
          });
        }

      }, 500);
    }
  }


  selectionChanged(): void {
    this.selectedDocumentId = this.getCurrentValue();
    this.docDescription = null;

    const document = (typeof this.value !== 'string' && this.selectedDocumentId != OTHER_OPTION) ? this.value : null;

    this.onSelectionChanged.emit({
      selection: {
        document: document,
        description: null
      }
    });

    this.focusOnDescriptionInput();
  }

  descriptionKeyup(): void {
    const otherDocumentSelected = (this.hasDocuments === false || this.selectedDocumentId === OTHER_OPTION)
      && this.docDescription !== null
      && this.docDescription.length >= 3;

    let document: ClientDocument | null = null;

    if (otherDocumentSelected) {
      // Instantiate new document with description and OTHER_OPTION id
      document = {
        id: OTHER_OPTION,
        fileDesc: this.docDescription ?? '',
        matterId: this.matterId,
        showInPortal: true,
        notAttached: false,
        parentId: null,
        requestedByAgent: false,
        fileCode: '',
        fileId: 0,
        clientId: 0,
        agentId: 0,
      } as ClientDocument;
    }

    this.onSelectionChanged.emit({
      selection: {
        document: document,
        description: otherDocumentSelected ? this.docDescription : null
      }
    });
  }

  private getCurrentValue(): string | null {
    if (!this.value || (typeof this.value === 'string')) {
      return this.value as string | null;
    }

    return this.value.id;
  }

  // TrackBy function for ngFor performance
  trackByDocId(index: number, doc: ClientDocument): any {
    return doc.id;
  }

}
